"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlSpanTagImporter = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var runs_1 = require("../containers/runs");
var string_1 = require("@devexpress/utils/lib/utils/string");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var rich_utils_1 = require("../../../core/model/rich-utils");
var HtmlSpanTagImporter = (function (_super) {
    tslib_1.__extends(HtmlSpanTagImporter, _super);
    function HtmlSpanTagImporter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importChilds = true;
        return _this;
    }
    HtmlSpanTagImporter.prototype.elementTag = function () {
        return "SPAN";
    };
    HtmlSpanTagImporter.prototype.importBefore = function () {
        var _a, _b;
        var tabCountStr = (_b = (_a = this.element.getAttribute('style')) === null || _a === void 0 ? void 0 : _a.split(';').find(function (e) { return e.startsWith('mso-tab-count:'); })) === null || _b === void 0 ? void 0 : _b.replace('mso-tab-count:', '');
        if (tabCountStr) {
            var count = parseInt(tabCountStr);
            this.importer.addRun(new runs_1.ImportedTextRunInfo(this.importer.modelManager.model, this.importer.measurer, string_1.StringUtils.repeat(rich_utils_1.RichUtils.specialCharacters.TabMark, count), this.importer.htmlImporterMaskedCharacterProperties.getBundleFrom(this.element, new fixed_1.FixedInterval(this.importer.currPosition, count))));
            this.importChilds = false;
        }
    };
    HtmlSpanTagImporter.prototype.isImportChilds = function () {
        return this.importChilds;
    };
    HtmlSpanTagImporter.prototype.importAfter = function () {
    };
    return HtmlSpanTagImporter;
}(base_1.HtmlTagImporterBase));
exports.HtmlSpanTagImporter = HtmlSpanTagImporter;
